const validator = {

    email: {
      rules: [
        {
          test: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
          message: 'Please Enter Valid Email',
        },
      ],
      errors: [],
      valid: false,
      state: '',
    },
    password: {
      rules: [
        {
          test: (value) => {
            return value.length >= 6;
          },
          message: 'Password can not be < 6 characters',
        },
        {
          test: /^[a-z0-9A-Z_]+$/,
          message: 'Enter Valid Password',
        },
      ],
      errors: [],
      valid: false,
      state: ''
    },
    username: {
      rules: [
        {
          test: /^(?=.{5,25}$)(?!.*[_.]{2})[a-zA-Z0-9._]$/i,
          message: 'please enter a valid username',
        },
      ],
      errors: [],
      valid: false,
      state: '',
    },
  };
  
  export default validator;